/**
 * ChannelCard Component
 * Now uses actual component code in the module
 */

export { default } from './ChannelCard';
export { default as ChannelCardSkeleton } from './ChannelCardSkeleton';
